import { render } from "./MethodContent.vue?vue&type=template&id=58fe85eb&lang=pug"
import script from "./MethodContent.vue?vue&type=script&lang=js"
export * from "./MethodContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__